import types from '@/actions/types';
import useContent from '@/composables/useContent';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class Website extends Base {
  constructor(params) {
    super(params, types.WEBSITE);

    this.timeout = null;
  }

  async execute() {
    const { resetCurrentContent, contentPromise } = useContent();
    const { trackAction } = useAnalytics();
    trackAction(this);

    // we need to wait until video of previous slide is finished before reset content and show website
    if (contentPromise.value) {
      await contentPromise.value;
    }

    resetCurrentContent();
    return new Promise((resolve) => {
      this.resolve = resolve;
      this.startTimeout();
    });
  }

  startTimeout() {
    if (this.params.timeout > 0) {
      this.timeout = setTimeout(this.resolve, this.params.timeout);
    }
  }

  stop() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (this.resolve) {
      this.resolve();
    }
  }

  pause() {
    clearTimeout(this.timeout);
  }

  resume() {
    this.startTimeout();
  }
}
